import type { ClientAdminsStressAssessmentResult } from '@fukuri-admins/apis/client/gen/model';

const VALUE_LABEL_LOW_TO_HIGH_AMOUNT = '（1: 少ない、5: 多い）';
const VALUE_LABEL_HIGH_TO_LOW_AMOUNT = '（1: 多い、5: 少ない）';
const VALUE_LABEL_LOW_TO_HIGH_LEVEL = '（1: 低い、5: 高い）';
const VALUE_LABEL_HIGH_TO_LOW_LEVEL = '（1: 高い、5: 低い）';

type DataPointConfig = {
  chartTitle: string;
  items: {
    label: string;
    key: keyof ClientAdminsStressAssessmentResult;
    valueLabel: string;
  }[];
};

export const DATA_POINT_CONFIGS: DataPointConfig[] = [
  {
    chartTitle: 'ストレス要因',
    items: [
      {
        label: '1. 心理的な仕事の負担（量）',
        key: 'psychological_workload_quantity',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT,
      },
      {
        label: '2. 心理的な仕事の負担（質）',
        key: 'psychological_workload_quality',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_LEVEL,
      },
      {
        label: '3. 自覚的な身体的負担度',
        key: 'subjective_physical_burden_level',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_LEVEL,
      },
      {
        label: '4. 職場の対人関係でのストレス',
        key: 'interpersonal_stress_at_work',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT,
      },
      {
        label: '5. 職場環境によるストレス',
        key: 'environmental_stress_at_work',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT,
      },
      {
        label: '6. 仕事のコントロール度',
        key: 'job_control_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_LEVEL,
      },
      {
        label: '7. 技能の活用度',
        key: 'skill_utilization_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_LEVEL,
      },
      {
        label: '8. 仕事の適性度',
        key: 'job_aptitude_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_LEVEL,
      },
      {
        label: '9. 働きがい',
        key: 'work_engagement_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_AMOUNT,
      },
    ],
  },
  {
    chartTitle: 'ストレス反応',
    items: [
      { label: '1. 活気', key: 'vitality_level', valueLabel: VALUE_LABEL_LOW_TO_HIGH_AMOUNT },
      {
        label: '2. イライラ感',
        key: 'irritability_level',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT,
      },
      { label: '3. 疲労感', key: 'fatigue_level', valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT },
      { label: '4. 不安感', key: 'anxiety_level', valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT },
      { label: '5. 抑うつ感', key: 'depression_level', valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT },
      {
        label: '6. 身体愁訴',
        key: 'physical_complaints_level',
        valueLabel: VALUE_LABEL_HIGH_TO_LOW_AMOUNT,
      },
    ],
  },
  {
    chartTitle: '周囲のサポート',
    items: [
      {
        label: '1. 上司からのサポート',
        key: 'supervisor_support_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_AMOUNT,
      },
      {
        label: '2. 同僚からのサポート',
        key: 'coworker_support_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_AMOUNT,
      },
      {
        label: '3. 家族友人からのサポート',
        key: 'family_friend_support_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_AMOUNT,
      },
      {
        label: '4. 仕事や生活の満足度',
        key: 'job_satisfaction_level',
        valueLabel: VALUE_LABEL_LOW_TO_HIGH_LEVEL,
      },
    ],
  },
];
